module.exports = __webpack_public_path__ + "img/20180815_151538_157.0f206d5f.jpg";